// extracted by mini-css-extract-plugin
export default {"segmented-control":"qEYsm","segmented-control_withPointer":"o4RPV","segmented-control_pointerMovable":"oh5yi"};